import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './assets/css/style.css'

import axios from 'axios'
import VueAxios from 'vue-axios'

axios.defaults.baseURL = 'https://onboarding.blixtpay.com/backend/api';
Vue.use(VueAxios, axios);
Vue.router = router;

Vue.config.productionTip = false

// Vue.prototype.$http = axios;

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
